import gql from 'graphql-tag';
import ORGANIZATION_FRAGMENT from 'graph/fragments/organization';
import CLASSROOM_FRAGMENT from 'graph/fragments/classroom';
import USER_CLASSROOM_ENROLLMENT_FRAGMENT from 'graph/fragments/user-classroom-enrollment';
const GET_ORGANIZATIONS = gql`
  query getClassroomAndOrganizations($where: ClassroomWhereInput!) {
    classroom(where: $where) {
      ...BaseClassroom
      users {
        ...BaseUserClassroomEnrollment
      }
      students {
        id
        username
      }
    }
    organizations(where: { type: [SCHOOL, USER_GROUP] }, orderBy: { field: NAME, direction: ASC }) {
      ...BaseOrganization
      users {
        user {
          id
          firstName
          lastName
          username
        }
      }
    }
  }
  ${CLASSROOM_FRAGMENT}
  ${USER_CLASSROOM_ENROLLMENT_FRAGMENT}
  ${ORGANIZATION_FRAGMENT}
`;

export default GET_ORGANIZATIONS;
